import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartSellerTabPure extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "invoice.vendeur.name")}
        pivots={["seller", "category", "product", "tiers"]}
        showColumns={["seller", "category", "product", "tiersAsClient"]}
        showPagination={false}
        showDetails={true}
        showExtra={true}
        defaultSorted={[
          {
            id: "seller",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartSellerTabPure;
